export default __webpack_public_path__ + "static/media/oscer-pres-shoulder-pain.91a3dc80.svg";